import React from 'react';

import Items from './Items';

const MenuItems = (props: TSFixMe) => {
  return <Items {...props} />;
};

export default MenuItems;
